let initialValues = localStorage.getItem("employment-application");
if(initialValues){
  initialValues = JSON.parse(initialValues);

  const bools = [
    "authorized",
    "availableEvenings",
    "availableHolidays",
    "availableWeekends",
    "convicted",
    "eighteenOrOver"
  ];

  //format bools as strings for redux-form
  bools.forEach(field => {
    initialValues[field] = initialValues[field] && initialValues[field] != "false" ? "true" : "false";
  });

  if(initialValues.employmentHistory){
    initialValues.employmentHistory.forEach(history => {
      history.canContactEmployer = history.canContactEmployer && history.canContactEmployer != "false" ? "true" : "false";
    });
  }
}else{
  initialValues: null;
}

export default function(){
  return initialValues;
}
